import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

export interface AtpApplicationApprovalDialogData {
  title: string;
  submissionType: 'link' | 'new' | string;
  applicationDate: string;
  applicationViableDate: string;
  approvalDate: string;
  atpOrId: string;
}

export interface AtpApplicationApprovalDialogResult {
  confirmed: boolean;
  applicationDate: string;
  applicationViableDate: string;
  approvalDate: string;
  atpOrId: string;
}

@Component({
  selector: 'app-atp-application-approval-dialog',
  templateUrl: './atp-application-approval-dialog.component.html'
})
export class AtpApplicationApprovalDialogComponent {
  form = new UntypedFormGroup({
    applicationDate: new UntypedFormControl('', [Validators.required]),
    applicationViableDate: new UntypedFormControl('', [Validators.required]),
    approvalDate: new UntypedFormControl('', [Validators.required]),
    atpOrId: new UntypedFormControl('')
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AtpApplicationApprovalDialogData,
    private readonly dialogRef: MatDialogRef<AtpApplicationApprovalDialogComponent>
  ) {
    this.form.patchValue({
      applicationDate: data?.applicationDate ?? '',
      applicationViableDate: data?.applicationViableDate ?? '',
      approvalDate: data?.approvalDate ?? '',
      atpOrId: data?.atpOrId ?? ''
    });
  }

  get questionText(): string {
    return this.data?.submissionType === 'link'
      ? 'Are you sure you want to approve this link request?'
      : 'Are you sure you want to approve this application?';
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const value = this.form.value;
    const result: AtpApplicationApprovalDialogResult = {
      confirmed: true,
      applicationDate: value.applicationDate,
      applicationViableDate: value.applicationViableDate,
      approvalDate: value.approvalDate,
      atpOrId: value.atpOrId
    };

    this.dialogRef.close(result);
  }
}
